export default __webpack_public_path__ + "static/media/Open Lock.30b3a2e4.svg";